import { getClassName } from 'src/Core/utility/jsx';
import styles from './typo.module.scss';

export function Heading1({ accent, className, children }) {
  return (
    <h1
      className={getClassName([
        styles.heading1,
        className,
        { [styles.accent]: accent },
      ])}
    >
      {children}
    </h1>
  );
}

export function Heading2({ accent, className, children }) {
  return (
    <h2
      className={getClassName([
        styles.heading2,
        className,
        { [styles.accent]: accent },
      ])}
    >
      {children}
    </h2>
  );
}

export function Heading3({ accent, className, children }) {
  return (
    <h3
      className={getClassName([
        styles.heading3,
        className,
        { [styles.accent]: accent },
      ])}
    >
      {children}
    </h3>
  );
}

export function Heading4({ accent, className, children }) {
  return (
    <h3
      className={getClassName([
        styles.heading4,
        className,
        { [styles.accent]: accent },
      ])}
    >
      {children}
    </h3>
  );
}

export function Title({ accent, className, children }) {
  return (
    <h3
      className={getClassName([
        styles.title,
        className,
        { [styles.accent]: accent },
      ])}
    >
      {children}
    </h3>
  );
}

export function SubTitle({ accent, className, children }) {
  return (
    <h3
      className={getClassName([
        styles.subtitle,
        className,
        { [styles.accent]: accent },
      ])}
    >
      {children}
    </h3>
  );
}

export function Body({ accent, className, children }) {
  return (
    <p
      className={getClassName([
        styles.body,
        className,
        { [styles.accent]: accent },
      ])}
    >
      {children}
    </p>
  );
}

export function SmallText({ accent, className, children }) {
  return (
    <p
      className={getClassName([
        styles.small,
        className,
        { [styles.accent]: accent },
      ])}
    >
      {children}
    </p>
  );
}

export function SecondaryText({ accent, className, children, extraSmall }) {
  return (
    <p
      className={getClassName([
        styles.secondary,
        className,
        { [styles.accent]: accent, [styles.extraSmall]: extraSmall },
      ])}
    >
      {children}
    </p>
  );
}

export function Info({ accent, className, children }) {
  return (
    <span
      className={getClassName([
        styles.info,
        className,
        { [styles.accent]: accent },
      ])}
    >
      {children}
    </span>
  );
}

export function Button({ className, children }) {
  return (
    <span className={getClassName([styles.button, className])}>{children}</span>
  );
}
